import React from 'react';
import { HStack, Image } from '@chakra-ui/react';
import { useInvestorAccountModel } from '@common/models/InvestorAccountModel';

export const PartnerLogo: React.FC = () => {
  const { investorAccount } = useInvestorAccountModel();
  if (!investorAccount?.partner) return null;

  const partnerLogo = investorAccount.partner.style.secondary_logo?.download_url;

  return (
    <HStack py="5px" px="24px" alignItems={'center'}>
      {partnerLogo && <Image h="24px" src={partnerLogo} />}
      {/* <Button
        fontWeight={'normal'}
        px="10px"
        fontSize={'10px'}
        borderRadius="15px"
        size={'xs'}
        colorScheme="gray"
        rightIcon={<Icon icon="arrow-right-long"></Icon>}>
        View Benefits
    </Button> */}
    </HStack>
  );
};
